import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
// import the core from Silegal App
import { AuthModule } from './auth/auth.module';
import { FeaturedModulesModule } from './featured-modules/featured-modules.module';
import { RandomColorPipe } from './shared/pipes/randomcolor.pipe';
import { CertificacionesModule } from './featured-modules/components/certificaciones/certificaciones-modules.module';

@NgModule({
  declarations: [
    AppComponent,
    RandomColorPipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
